import React from 'react';
import { AuthFlow } from './AuthFlow';

const Register: React.FC = () => {
  return <AuthFlow defaultMode="signup" />;
};

export default Register;
